module.exports = __webpack_public_path__ + "media/bootstrap-icons/tropical-storm-a87c9d6d.svg";